const stripNonDigits = fieldValue => {
  return ('' + fieldValue).replace(/\D/g, '');
};

export default stripNonDigits;
